import { createSlice } from '@reduxjs/toolkit';

import { IWaitingUsersResponse } from '@/types/key-exchange';

export type TNotificationMode = 'SILENT' | 'GENERAL';
interface UserPreferencesState {
    isInUploadKeyPage: boolean | null;
    peerFound: string;
    p2pConnection: string | null;
    p2pKeys;
    subserverKeys: { publicKey?: {}; privateKey?: {} };
    isP2PPanelOpen: boolean;
    availableCondition: boolean;
    targetUser: string | undefined;
    permitUsers: any[];
    notificationMode: TNotificationMode;
    waitingList: {
        [connection_id: string]: IWaitingUsersResponse;
    };
}

const storageValue = localStorage.getItem('p2p-exchange-notification-mode');

const initialState: UserPreferencesState = {
    isInUploadKeyPage: null,
    peerFound: '',
    p2pConnection: null,
    availableCondition: false,
    p2pKeys: {},
    permitUsers: [],
    subserverKeys: {},
    targetUser: undefined,
    isP2PPanelOpen: false,
    notificationMode: (storageValue as TNotificationMode) || 'GENERAL',
    waitingList: {},
};

const p2pSlice = createSlice({
    name: 'user-preferences',
    initialState,
    reducers: {
        updateIsInKeyUpload(state, action) {
            state.isInUploadKeyPage = action.payload;
        },
        switchNotificationMode(state) {
            const value =
                state.notificationMode === 'GENERAL' ? 'SILENT' : 'GENERAL';
            state.notificationMode = value;
            localStorage.setItem('p2p-exchange-notification-mode', value);
        },
        updatePeerFound(state, action) {
            state.peerFound = action.payload;
        },
        updateP2PSConnection(state, action) {
            state.p2pConnection = action.payload;
        },

        setP2PKeys(state, action) {
            state.p2pKeys = {
                JSON_SERVER: action.payload.JSON_SERVER,
                JSON_USER: action.payload.JSON_USER,
            };
        },
        updateP2PKeys(state, action) {
            state.subserverKeys = action.payload;
        },
        toggleP2PPanel(state, action) {
            const { state: actionState = undefined, target = undefined } =
                action.payload;

            state.targetUser = target;

            if (actionState !== undefined) {
                if (state.isP2PPanelOpen !== actionState)
                    state.isP2PPanelOpen = actionState;
            } else {
                state.isP2PPanelOpen = !state.isP2PPanelOpen;
            }
        },
        updateWaitingUser(state, action) {
            state.waitingList[action.payload?.device_id] = action.payload;
        },
        removeWaitingUser(state, action) {
            const device_id = action.payload;
            delete state.waitingList[device_id];
        },
        setAvailableCondition(state, action) {
            state.availableCondition = action.payload;
        },
        updatePermittedList(state, action) {
            state.permitUsers = action.payload;
        },
    },
});

export const p2pActions = p2pSlice.actions;
export default p2pSlice.reducer;
